import { Component, OnInit } from '@angular/core';
import { ETNotification } from '@src/app/models/ETnotification';
import { NotificationlistService } from './service/notificationlist.service';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { NotificationStateService } from '@src/app/helpers/notification-state.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-notificationlist',
  templateUrl: './notificationlist.component.html',
  styleUrls: ['./notificationlist.component.css']
})
export class NotificationlistComponent implements OnInit {
  notificationList:ETNotification[];
  newNotificationList:ETNotification[];
  oldNotificationList:ETNotification[];
  constructor(
    private nlsrv:NotificationlistService,
  private datastore:DatastoreService,
  private uievent:UieventhubService,
  private notificationState: NotificationStateService
  ) { }

  ngOnInit(): void {
    this.datastore.notifications$.pipe(untilDestroyed(this)).subscribe(nlist =>{
      const snapshot = this.notificationState.buildState(nlist);
      this.notificationList = snapshot.all;
      this.newNotificationList = snapshot.unread;
      this.oldNotificationList = snapshot.read;
    });
  }

}
